import { of as observableOf } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
var AutocompleteSearchComponent = /** @class */ (function () {
    function AutocompleteSearchComponent() {
        this.itemSearch = new FormControl('');
        this.formControl = new FormControl('');
        this.propagateChange = function (value) { return ({}); };
    }
    Object.defineProperty(AutocompleteSearchComponent.prototype, "items", {
        set: function (value) {
            var _this = this;
            if (!value) {
                this.itemList = observableOf([]);
                return;
            }
            this._items = value;
            this.itemList = this.itemSearch.valueChanges.pipe(startWith(null), map(function (search) { return (search ? _this.applyFilter(search) : value.slice()); }));
        },
        enumerable: true,
        configurable: true
    });
    AutocompleteSearchComponent.prototype.ngOnInit = function () {
        this.itemList = observableOf([]);
    };
    AutocompleteSearchComponent.prototype.applyFilter = function (value) {
        var _this = this;
        return this._items.filter(function (item) { return _this.filter(value, item); });
    };
    AutocompleteSearchComponent.prototype.writeValue = function (value) {
        this.itemSearch.setValue(value);
        this.formControl.setValue(value);
    };
    AutocompleteSearchComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    AutocompleteSearchComponent.prototype.registerOnTouched = function () {
        // lint
    };
    AutocompleteSearchComponent.prototype.updateValue = function (option) {
        this.propagateChange(option.value);
    };
    return AutocompleteSearchComponent;
}());
export { AutocompleteSearchComponent };
